<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                <h2 class="mb-4">FollowUp ({{ todayFollowup + pendingFollowup + completeFollowup}})</h2>
                <!-- <div style="float: right;">
                        <button type="button" class="btn btn-primary" (click)="addStaff()">Add Subfranchise</button>
                    </div> -->
                <div class="container-fluid mt-3">
                    <div class="row g-2 align-items-center">

                        <!-- Search box -->
                        <div class="col-md-3">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Name, Email, Mobile"
                                    [(ngModel)]="filters.search" name="search" />
                                <button *ngIf="filters.search" class="clear-btn" (click)="clearSearch()">✕</button>
                            </div>
                        </div>

                        <!-- Staff dropdown -->
                        <div class="col-md-2" *ngIf="rsbLookup.getLoggedUser().type == 'franchise' || rsbLookup.getLoggedUser().type == 'subfranchise'">
                            <select class="form-select" [(ngModel)]="filters.staffName" name="staff"
                                (change)="selectStaff($event)">
                                <option value="0">-- Select Staff --</option>
                                <option *ngFor="let staff of allStaffRecordsList" [value]="staff.franchiseId">{{
                                    staff.personalDetails.firstName }}</option>
                            </select>
                        </div>

                        <!-- Status dropdown
                        <div class="col-md-2">
                            <select class="form-select" [(ngModel)]="filters.status" name="status">
                                <option value="0">-- Select Status --</option>
                                <option *ngFor="let s of statusList" [value]="s.value">{{ s.name }}</option>
                            </select>
                        </div> -->

                        <!-- Category dropdown -->
                        <div class="col-md-2">
                            <select class="form-select" [(ngModel)]="filters.category" name="category">
                                <option value="0">-- Select Category --</option>
                                <option *ngFor="let c of mainModules" [value]="c.mainModuleId">{{ c.moduleName}}
                                </option>
                            </select>
                        </div>

                        <!-- Search button -->
                        <div class="col-md-2 d-flex gap-2">
                            <button type="button"
                                class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                                (click)="applyFilters()">
                                <i class="fa fa-search me-2"></i> Search
                            </button>
                            <button type="button"
                                class="btn btn-secondary w-100 d-flex align-items-center justify-content-center"
                                (click)="resetFilters()">
                                <i class="fa fa-refresh me-2"></i> Reset
                            </button>
                        </div>

                    </div>
                </div>
                <div class="leads-btns">
                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': statusType === 'pending',
                                'btn-outline-light': statusType !== 'pending'
                              }" (click)="getStaff('pending','',true)">
                        Lapse FollowUp({{pendingFollowup || 0}})
                    </button>
                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': statusType === 'today',
                                'btn-outline-light': statusType !== 'today'
                              }" (click)="getStaff('today','',true)">
                        Today FollowUp({{todayFollowup || 0}})
                    </button>
                    <button class="btn me-2" [ngClass]="{
                                'btn-gold': statusType === 'complete',
                                'btn-outline-light': statusType !== 'complete'
                              }" (click)="getStaff('complete','', true)">
                        Future FollowUp({{completeFollowup || 0}})
                    </button>
                </div>
                <!-- Data Table -->
                <div class="table-responsive thtdfix">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>

                                <th>S.No</th>
                                <th>Property Info</th>
                                <th>Lead ID</th>
                                <th>Category</th>
                                <th>Lead Type</th>
                                <th>Product</th>
                                <th>Product Value</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Followup Date</th>
                                <th>Service Type</th>
                                <th>Status</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let records of allStaffRecords; let i =index;">
                                <tr style="cursor: pointer;">
                                    <td>{{ i+1}}</td>
                                    <td class="property-info-cell" (click)="redirectUrl(records)"> <img
                                            src="{{records.images.length ? records?.images[0] :''}}"
                                            class="property-info-icon" />{{ generateTitle(records) }}</td>
                                    <td>{{ records?.leadId }}</td>
                                    <span
                                        [ngClass]="getCategoryClass(leadRec?.mainModuleName || leadRec?.serviceType )">
                                        <td>{{records?.mainModuleName || records?.serviceType}}</td>
                                    </span>
                                    <td><span [ngClass]="getLeadTypeClass(leadRec?.leadType)">{{records?.leadType ||
                                            ''}}</span>
                                    </td>
                                      <td><span [ngClass]="getProductClass(leadRec?.product)">{{ records?.product ||
                                        ''}}</span>
                                </td>
                                <td>{{ records?.price}}</td>
                                    <td (click)="toggleRow(i)">{{records?.customerName}}</td>
                                    <td (click)="toggleRow(i)">{{records?.email}}</td>
                                    <td (click)="toggleRow(i)">{{records?.mobile}}</td>
                                    <td (click)="toggleRow(i)">{{records?.date | date:'short':'IST' }}</td>
                                    <td (click)="toggleRow(i)">{{records?.propType}}</td>
                                      <td>
                                    <ng-container *ngIf="editIndex === i; else displayRemark" style="cursor: pointer;">
                                        <select [(ngModel)]="editRowValues[i].status" #statusCtrl="ngModel" required
                                            >
                                            <option value="0">Select Value</option>
                                            <option *ngFor="let option of statusList" [value]="option.value">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                        <div *ngIf="(statusCtrl.invalid && statusCtrl.touched) || (editRowValues[i].status === '0' && saveAttempted)"
                                            class="text-danger small mt-1">
                                            Please select a valid status.
                                        </div>
                                    </ng-container>
                                    <ng-template #displayRemark>
                                        <span (click)="startEditingRow(i)">{{ getStatusName(records.status) || "Verified
                                            Lead" }}</span>
                                    </ng-template>
                                </td>
                                
                                <td>
                                    <span [title]="leadRec?.remarks" style="cursor: pointer;"
                                        [ngClass]="getStatusClass(records?.description)">
                                        <ng-container *ngIf="editIndex === i; else displayRemarks">
                                            <input type="text" name="remarks{{i}}" [(ngModel)]="editRowValues[i].remarks"
                                                #remarksCtrl="ngModel" required minlength="5"
                                                autofocus style="height:50px;" />
                                            <div *ngIf="remarksCtrl.invalid && (remarksCtrl.touched || saveAttempted)"
                                                class="text-danger small mt-1">
                                                <span *ngIf="remarksCtrl.errors?.required || (saveAttempted && editRowValues[i].remarks.trim().length === 0)">Remarks are
                                                    required.</span>
                                                <span *ngIf="remarksCtrl.errors?.minlength || (saveAttempted && editRowValues[i].remarks.trim().length > 0 && editRowValues[i].remarks.trim().length < 5)">Must be at least 5
                                                    characters.</span>
                                            </div>
                                            
                                        </ng-container>

                                        <ng-template #displayRemarks>
                                            <span (click)="startEditingRow(i)">{{ records.description }}</span>
                                        </ng-template>
                                    </span>

                                </td>
                                <td>
                                    <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex !== i" (click)="startEditingRow(i)">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex !== i"   (click)="toggleRow(i)"><i class="fa-solid fa-clock-rotate-left"></i></button>
                                    <button class="btn btn-sm btn-outline-primary me-2"  *ngIf="editIndex == i" (click)="saveRemark(records,i)"><i class="fa-solid fa-check"></i></button>
                                     <button class="btn btn-sm btn-outline-primary me-2" *ngIf="editIndex == i" (click)="closeEdit(i)"><i class="fa-solid fa-xmark" style="color: red;"></i></button>

                                    <!-- Add any action buttons here -->
                                </td>

                                </tr>
                                <ng-container *ngIf="expandedIndex === i">
                                    <tr>
                                        <td colspan="12" class="bg-light">
                                            <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                                <a (click)="toggleRow(i)" style="cursor: pointer;"><i
                                                        class="fa-solid fa-chevron-up text-right d-block mb-2"></i> </a>
                                                <p *ngFor="let history of childData" class="mb-1">
                                                    <b>{{history.createdAt | date:'short':'IST'}}:</b>
                                                    {{history.description}}- <b>Followup Date</b>: <b
                                                        class="text-primary" style="color: green;">{{history.date |
                                                        date:'short':'IST'}} </b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>

                        </tbody>
                    </table>
                </div>
                    <mat-paginator [length]="totalRecords" [pageSize]="pageSize" showFirstLastButtons
                        (page)="onPageChange($event)">
                    </mat-paginator>
            </div>
        </main>

    </div>
</div>